<template>
  <div>
    <multi-bar
      title="当年按月到款统计"
      :data="chartData"
      legendPosition="top"
      :aspectRatio="2.5"
      :series="[
        {value: 'income', label: '项目到款', yAxisID: 'y-axis-2', 'fill': false, type: 'line'},
        {value: 'zxIncome', label: '纵向到款', yAxisID: 'y-axis-2', 'fill': false, type: 'line'},
        {value: 'hxIncome', label: '横向到款', yAxisID: 'y-axis-2', 'fill': false, type: 'line'},
        {value: 'yjIncome', label: '研究经费', yAxisID: 'y-axis-2', 'fill': false, type: 'line'},
      ]"/>
    <v-divider/>
    <v-responsive style="height: 85px;">
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex xs11>
            <v-layout row wrap>
              <v-flex xs4>
                <p class="text-xs-center mb-0">{{currentLabel0}}</p>
                <p class="text-xs-center headline" style="color: #0d47a1">{{income}}</p>
              </v-flex>
              <v-flex xs4>
                <p class="text-xs-center mb-0">{{currentLabel1}}</p>
                <p class="text-xs-center headline" style="color: #0d47a1">{{hxIncome}}</p>
              </v-flex>
              <v-flex xs4>
                <p class="text-xs-center mb-0">{{currentLabel2}}</p>
                <p class="text-xs-center headline" style="color: #0d47a1">{{yjIncome}}</p>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs1 class="align-content-end">
            <v-tooltip>
              <v-btn small icon class="mx-50"
                     slot="activator" :to="'/index/HeadSubFund/Fund'">
                <v-icon color="teal">more_horiz</v-icon>
              </v-btn>
              <span>更多统计图表</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-container>
    </v-responsive>
  </div>
</template>

<script>
  import MultiBar from './MultiBar'

  const uri = '/api/proj/report/fund-by-year';

  export default {
    components: {MultiBar},
    data() {
      return {
        chartData: null,

        income: "",
        hxIncome:"",
        yjIncome:"",
      }
    },
    created() {
      this.axios.get(uri).then(
        rsp => {
          this.chartData = rsp.data.map(v => {v.label = v.label.substr(5); return v});
          this.loading = false;

          let tmp = 0;
          rsp.data.forEach(v => tmp += v.income);
          this.income = Math.round( tmp * 100) / 100;

          tmp = 0;
          rsp.data.forEach(v => tmp += v.hxIncome);
          this.hxIncome = Math.round( tmp * 100) / 100;

          tmp = 0;
          rsp.data.forEach(v => tmp += v.yjIncome);
          this.yjIncome = Math.round( tmp * 100) / 100;

          // window.console.log("XXX")
        }
      )
    },

    computed: {
      currentLabel0() {
        return this.chartData ? "总到款" : ""
      },
      currentLabel1() {
        return this.chartData ? "横向到款" : ""
      },
      currentLabel2() {
        return this.chartData ? "研究经费" : ""
      }
    }
  }
</script>

<style scoped>

</style>
